// @flow

import styled from 'styled-components';
import Button from '../../../../../button';
import type { Theme } from '../../../../../../types';

export default styled<typeof Button, Theme, _>(Button)`
  min-width: 0;
  height: 2.25rem;
  white-space: nowrap;
`;
